module.exports = __webpack_public_path__ + "static/img/logoWap-white.262ebd64.png";